import React from 'react'
import LabelTitleText from 'components/shared/LabelTitleText'
import classnames from 'classnames/bind'
import TimelineEntry from './TimelineEntry'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const ChangelogsTimeline = ({ className, intro, changelogs }) => {
  return (
    <div className={cx(className)}>
      {intro && (
        <LabelTitleText
          className={css.intro}
          {...intro}
          children={
            changelogs &&
            changelogs.map((changelog, index) => (
              <TimelineEntry
                key={changelog.id}
                firstElement={index === 0}
                {...changelog}
              />
            ))
          }
        />
      )}
    </div>
  )
}

ChangelogsTimeline.defaultProps = {}

export default ChangelogsTimeline
